import {
  ENUM_VALUE_TYPE,
  STRING_VALUE_TYPE,
  CELL_LAYOUT_TYPE,
} from 'grb-webui/components/FilterBar';

export default ({ createTimeRangeEditor }) => ({
  emptyChipLabel: 'All objects',
  dialogClassName: 'grb-storage-object-dialog-filter',
  server: true,
  searchKey: 'search',
  propertyEditors: [
    {
      title: 'Object ID',
      name: 'id',
      type: STRING_VALUE_TYPE,
    },
    {
      title: 'Username',
      name: 'username',
      type: STRING_VALUE_TYPE,
    },
    {
      title: 'Container Name',
      name: 'container',
      type: STRING_VALUE_TYPE,
    },
    {
      title: 'Object Name',
      name: 'name',
      type: STRING_VALUE_TYPE,
    },
    {
      title: 'Object limit',
      name: 'length',
      type: ENUM_VALUE_TYPE,
      layout: CELL_LAYOUT_TYPE,
      namedValues: [
        { value: 100, label: '100 objects' },
        { value: 200, label: '200 objects' },
        { value: 500, label: '500 objects' },
      ],
      defaultValue: 200,
      getValueLabel(value) {
        return value === undefined ? 'All objects' : `${value} objects`;
      },
    },
    createTimeRangeEditor({
      title: 'Creation time range',
      getObjectDate: k => new Date(k.createdAt || 0),
    }),
  ],
});

